import React from "react"
import { View, TouchableOpacity } from "react-native"
import { theme } from "@common/theme/theme"
import TextM from "@common/components/text/TextM"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { IconImageM } from "@common/components/icons/IconsM"
import moment from "moment"

const AIPreviewSection = ({ aiPreviewData, onEdit }) => {
    if (!aiPreviewData) return null

    return (
        <View
            style={{
                marginTop: 20,
                padding: 20,
                backgroundColor: theme.colors.successLight,
                borderRadius: theme.roundness,
                borderWidth: 2,
                borderColor: theme.colors.success,
            }}
        >
            {/* Success header */}
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginBottom: 16,
                }}
            >
                <View
                    style={{
                        width: 28,
                        height: 28,
                        borderRadius: 14,
                        backgroundColor: theme.colors.success,
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: 10,
                    }}
                >
                    <FontAwesome5
                        name="check"
                        size={14}
                        color={theme.colors.white}
                    />
                </View>
                <TextM
                    fontSize={16}
                    fontWeight="Bold"
                    color={theme.colors.successDark}
                >
                    C'est bon, on a tout trouvé !
                </TextM>
            </View>

            {/* Subject with icon */}
            {aiPreviewData.subject && (
                <PreviewCard>
                    {aiPreviewData.subject.icon && (
                        <IconImageM
                            uri={aiPreviewData.subject.icon}
                            width={24}
                            style={{ marginRight: 10 }}
                        />
                    )}
                    <View style={{ flex: 1 }}>
                        <TextM fontSize={12} color={theme.colors.grey}>
                            Matière
                        </TextM>
                        <TextM fontSize={15} fontWeight="SemiBold" wrap>
                            {aiPreviewData.subject.name}
                        </TextM>
                    </View>
                </PreviewCard>
            )}

            {/* Chapters */}
            {aiPreviewData.chapters && aiPreviewData.chapters.length > 0 && (
                <PreviewCard>
                    <View style={{ flex: 1 }}>
                        <TextM
                            fontSize={12}
                            color={theme.colors.grey}
                            style={{ marginBottom: 4 }}
                        >
                            Chapitres
                        </TextM>
                        <TextM fontSize={15} fontWeight="SemiBold" wrap>
                            {aiPreviewData.chapters.map((c) => c.name).join(", ")}
                        </TextM>
                    </View>
                </PreviewCard>
            )}

            {/* Exam Date */}
            {aiPreviewData.exam_date && (
                <PreviewCard row>
                    <FontAwesome5
                        name="calendar-alt"
                        size={18}
                        color={theme.colors.primary}
                        style={{ marginRight: 10 }}
                    />
                    <View style={{ flex: 1 }}>
                        <TextM fontSize={12} color={theme.colors.grey}>
                            Date du contrôle
                        </TextM>
                        <TextM fontSize={15} fontWeight="SemiBold">
                            {moment(aiPreviewData.exam_date).format(
                                "dddd D MMMM YYYY"
                            )}
                        </TextM>
                    </View>
                </PreviewCard>
            )}

            {/* Key Requirements */}
            {aiPreviewData.key_requirements &&
                aiPreviewData.key_requirements.length > 0 && (
                    <PreviewCard>
                        <View style={{ flex: 1 }}>
                            <TextM
                                fontSize={12}
                                color={theme.colors.grey}
                                style={{ marginBottom: 8 }}
                            >
                                À réviser
                            </TextM>
                            {aiPreviewData.key_requirements.map((req, index) => (
                                <View
                                    key={index}
                                    style={{
                                        flexDirection: "row",
                                        alignItems: "flex-start",
                                        marginBottom:
                                            index <
                                            aiPreviewData.key_requirements.length - 1
                                                ? 6
                                                : 0,
                                    }}
                                >
                                    <View
                                        style={{
                                            width: 6,
                                            height: 6,
                                            borderRadius: 3,
                                            backgroundColor: theme.colors.success,
                                            marginTop: 6,
                                            marginRight: 10,
                                        }}
                                    />
                                    <TextM fontSize={14} style={{ flex: 1 }} wrap>
                                        {req}
                                    </TextM>
                                </View>
                            ))}
                        </View>
                    </PreviewCard>
                )}

            {/* Edit link */}
            <TouchableOpacity
                onPress={onEdit}
                style={{
                    alignSelf: "center",
                    paddingVertical: 8,
                }}
            >
                <TextM
                    fontSize={14}
                    color={theme.colors.primary}
                    fontWeight="SemiBold"
                >
                    Modifier les infos
                </TextM>
            </TouchableOpacity>
        </View>
    )
}

function PreviewCard({ children, row = false }) {
    return (
        <View
            style={{
                flexDirection: row ? "row" : "column",
                alignItems: row ? "center" : "stretch",
                marginBottom: 12,
                backgroundColor: theme.colors.white,
                padding: 12,
                borderRadius: 10,
            }}
        >
            {children}
        </View>
    )
}

export default AIPreviewSection
